import React from 'react';

const AwardChapter = (props) => (
    <div className="panel-adt">
        <h2>{props.chapter.game.title} Awards</h2>
        <ul className="media-list">
            {props.children}
        </ul>
    </div>
);


export default AwardChapter;


// WEBPACK FOOTER //
// ./src/Awards/AwardChapter.js